/**
 * Small helpers for Beheer › Leveringszones: amounts and distances as the owner types them, and the
 * delivery hours ("17", "17.00" or "17h00" all mean 17:00).
 */
import type { Cents } from "../../lib/money";
import { formatAmount, parseAmount } from "../../lib/money";

/** "0,50", "15,00" or "" (null): an amount always with its cents (Furkan, 18/10/2026). */
export const amountText = (cents: Cents | null) => (cents === null ? "" : formatAmount(cents));

/** An amount field: empty = null, otherwise cents; undefined when it cannot be read. */
export function readAmount(text: string): Cents | null | undefined {
  const value = text.trim();
  if (value === "") return null;
  return parseAmount(value) ?? undefined;
}

/** A distance in km with a comma: "4,5". */
export const kmText = (km: number | null) => (km === null ? "" : String(km).replace(".", ","));

export function readKm(text: string): number | null | undefined {
  const value = text.trim().replace(",", ".");
  if (value === "") return null;
  const km = Number(value);
  return Number.isFinite(km) && km >= 0 && km <= 500 ? Math.round(km * 10) / 10 : undefined;
}

export { readTime } from "../../lib/time";
